import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PageHeader from "@/components/PageHeader";
import StructurePatient from "@/pages/admin/StructurePatient";
import StructureModules from "@/pages/admin/StructureModules";

// Admin > Structure: the stored structure that every form, validator and results view is generated from.
export default function Structure() {
  return (
    <div>
      <PageHeader
        eyebrow="Configuration"
        title="Structure"
        description="Admin area. This is where you define what can be configured: which settings a patient has and their limits, the catalogue of activities (what each is for and what each difficulty level means), and what a patient can have. Therapies are managed by therapists under Clinical > Therapies. Therapists see the result as forms and the Activity guide."
      />
      <Tabs defaultValue="patient">
        <TabsList className="mb-4">
          <TabsTrigger value="patient" data-testid="tab-structure-patient">Patient structure</TabsTrigger>
          <TabsTrigger value="modules" data-testid="tab-structure-modules">Modules</TabsTrigger>
        </TabsList>
        <TabsContent value="patient"><p className="text-sm text-slate-600 mb-3">The settings every patient has (treatment rules per area, reach, program length), their allowed ranges and defaults. Each group becomes a tab on the patient page.</p><StructurePatient /></TabsContent>
        <TabsContent value="modules"><p className="text-sm text-slate-600 mb-3">The catalogue of activities: what each is for, what each difficulty level changes, and the options therapists can set. This feeds the Activity guide and every assignment form. Import/Export here are for admins moving definitions between systems.</p><StructureModules /></TabsContent>
      </Tabs>
    </div>
  );
}
